import React from 'react';

import classes from './WhatYouWillGet.module.scss';

const benefits = [
    {
        key: 'courses',
        eyebrow: 'Courses & Career paths',
        title: 'Pharma courses for every role and level',
        description: 'Build job-ready skills with expert-led GMP, QA, QC, Regulatory Affairs, and Pharmacovigilance courses. Follow guided career paths and earn certificates.',
    },
    {
        key: 'assessments',
        eyebrow: 'Assessments',
        title: 'Measure your pharma career readiness',
        description: 'Take role-based assessments to discover your strengths, skill gaps, and next learning steps. Get clear insights to choose the right courses faster.',
    },
    {
        key: 'resume',
        eyebrow: 'Resume to Professional Profile',
        title: 'Resume to Professional Profile',
        description: 'AI helps turn your resume into a public professional profile and gives you feedback to improve how you present your skills, experience, and learning progress.',
    },
    {
        key: 'career-radar',
        eyebrow: 'Career',
        title: 'Career Competency Radar',
        description: 'AI analyzes your profile and creates a Career Competency Radar, giving you a clearer view of your strengths, gaps, and career readiness.',
    },
    {
        key: 'market-benchmark',
        eyebrow: 'Resume to Professional Profile',
        title: 'Market Benchmark Comparison',
        description: 'Your radar can be compared with average job expectations across different countries, pharma roles, and skill levels, helping you understand where you stand.',
    },
    {
        key: 'job-matching',
        eyebrow: 'Career',
        title: 'Job Board & Job Radar Matching',
        description: 'For each pharma job, AI creates a job-specific competency radar and compares it with yours, so you can see how well you match and what to improve next.',
    },
];

const WhatYouWillGet = () => {
    return (
        <section className={classes['wrapper']}>
            <div className="container d-flex flex-column align-items-center w-100">
                <div className={classes['intro']}>
                    <h2><span>Unlock Premium</span> benefits</h2>
                    <p>
                        With Pharmuni Premium, enjoy VIP access to exclusive resources and personalized career
                        consultations, giving you the edge in finding your dream job in the pharmaceutical industry.
                        Enhance your skills, receive expert guidance, and elevate your career to the next level.
                    </p>
                </div>
                <div className={classes['grid']}>
                    {benefits.map((benefit) => (
                        <article key={benefit.key} className={classes['card']}>
                            <span className={classes['eyebrow']}>{benefit.eyebrow}</span>
                            <h3>{benefit.title}</h3>
                            <p>{benefit.description}</p>
                            <div
                                className={`${classes['illustration']} ${classes[`img-${benefit.key}`]}`}
                                role="img"
                                aria-label={benefit.title}
                            />
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhatYouWillGet;
